import { render, staticRenderFns } from "./EcommerceBrowserStates.vue?vue&type=template&id=be4967de&"
import script from "./EcommerceBrowserStates.vue?vue&type=script&lang=js&"
export * from "./EcommerceBrowserStates.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceBrowserStates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports